<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-agenda`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 4a2 2 0 011.995 1.85L42 6v37a2 2 0 01-1.85 1.995L40 45H8a2 2 0 01-1.995-1.85L6 43V6a2 2 0 011.85-1.995L8 4h32zm-2 4H26.999L27 18.929a2 2 0 01-2.809 1.829L20 18.905l-4.191 1.853A2 2 0 0113 18.928L12.999 8H10v33h28V8zm-4 25a1 1 0 011 1v1.5a1 1 0 01-1 1H14a1 1 0 01-1-1V34a1 1 0 011-1h20zm0-7a1 1 0 011 1v1.5a1 1 0 01-1 1H14a1 1 0 01-1-1V27a1 1 0 011-1h20zM22.999 8h-6L17 15.858l3-1.327 3 1.327L22.999 8z"/></svg>
</template>
<script>

export default {
  name: 'IconAgenda',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
